import React from 'react';

import Col from 'react-bootstrap/Col';
import EditorSaveCancel from '../shared/buttons/EditorSaveCancel';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import Row from 'react-bootstrap/Row';
import SelectList from '../shared/inputs/SelectList';
import permissionsProvider from '../../utilities/permissionsProvider';

const EditForm = ({
    form: { item },
    form: { formChange },
    submitForm,
    cancelEdit
}) => {
    const disabled = !permissionsProvider.canEdit(item.acl);

    return (
        <div>
            <div className="item-editor">
                <Row className="justify-content-end">
                    <Col xs="auto" className="fields-required-label" />
                </Row>
                <Form.Row>
                    <Col>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <FormControl
                                    defaultValue={item.date}
                                    name="date"
                                    onChange={formChange}
                                    placeholder="Date"
                                    type="date"
                                    validationError={item.date_error}
                                    disabled={disabled}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <SelectList
                                    lookupType="AppUser"
                                    name="userId"
                                    onChange={formChange}
                                    placeholder="User"
                                    required={true}
                                    validationError={item.userId_error}
                                    value={item.userId}
                                    disabled={disabled}
                                />
                            </Form.Group>
                        </Form.Row>
                    </Col>
                    <Form.Group as={Col} sm={6}>
                        <FormControl
                            as="textarea"
                            defaultValue={item.description}
                            name="description"
                            onChange={formChange}
                            placeholder="Description"
                            required
                            rows="6"
                            validationError={item.description_error}
                            disabled={disabled}
                        />
                    </Form.Group>
                </Form.Row>
            </div>
            <EditorSaveCancel
                save={submitForm}
                cancel={cancelEdit}
                acl={item.acl}
            />
        </div>
    );
}

export default EditForm;